<template>
  <div v-if="hasEbook" class="ebook-section pt-5">
    <h5 class="page-title mb-4">Ebook</h5>

    <div class="ebook-list">
      <div
        v-for="file in files"
        :key="file.id"
        class="ebook-item"
        role="button"
        tabindex="0"
        @click="openViewer(file)"
        @keyup.enter="openViewer(file)"
      >
        <div class="ebook-cover">
          <img
            :src="file.cover_url || defaultCoverImg"
            :alt="file.title"
            class="ebook-cover-img"
            @error="onCoverError($event)"
          />
        </div>
        <p class="ebook-title mt-2">{{ file.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import defaultCoverImg from "@/assets/images/logo-dark.svg";

export default {
  name: "EbookSection",
  data() {
    return {
      defaultCoverImg
    };
  },
  computed: {
    ...mapState("ebookReader", ["files"]),
    ...mapGetters("ebookReader", ["hasEbook"])
  },
  methods: {
    openViewer(file) {
      this.$store.commit("ebookReader/setCurrentFile", file);
      this.$router.push({ name: "ebook-viewer", params: { fileId: file.id } });
    },
    onCoverError(event) {
      event.target.src = defaultCoverImg;
    }
  }
};
</script>

<style lang="scss" scoped>
.ebook-section {
  .ebook-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .ebook-item {
    cursor: pointer;
    width: 140px;
    outline: none;

    &:hover .ebook-cover {
      border: 2px solid #3e56ac;
    }

    &:focus .ebook-cover {
      border: 2px solid #3e56ac;
    }

    @media screen and (max-width: 400px) {
      width: 120px;
    }
  }

  .ebook-cover {
    border-radius: 6px;
    overflow: hidden;
    aspect-ratio: 200 / 290;
    background-color: #151823;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid transparent;
    transition: border 0.15s ease-in-out;

    .ebook-cover-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }

  .ebook-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    margin: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
